import styled from 'styled-components';
import { COLOR, TYPOGRAPHY, FONT } from '../../../../../theme/constants';
import config from './../../../../../config';

export const TableChartCell = styled.td<{ chartToggleState: string }>`
   width: 50px;
   font-size: 16px;
   text-align: center;
   padding: 17px 6px;
   position: relative;
   border-top: 1px solid ${COLOR.LIGHTGREY};

   //default uncharted state
   background: url('${config.baseName}/images/ChartPlotNotSelect.svg') 50% 50% no-repeat;
   background-size: 24px 24px;
   cursor: pointer;
   -moz-transition: 100ms;
   -webkit-transition: 100ms;
   transition: 100ms;
   cursor: default;

   ${props => {
      switch (props.chartToggleState) {
         case 'chartable':
            return `
          &:hover {
            background: url('${config.baseName}/images/ChartPlotNotSelect.svg') 50% 50% no-repeat #F9FFEF;
            background-size: 24px 24px;
            cursor: pointer;
          }
        `;
         case 'charted':
            return `
          background: url('${config.baseName}/images/ChartPlotSelect.svg') 50% 50% no-repeat ;
          background-size: 24px 24px;
          &:hover {
            background: url('${config.baseName}/images/ChartPlotSelect.svg') 50% 50% no-repeat #FFEFF9;
            background-size: 24px 24px;
            cursor: pointer;
          }
        `;
         case 'unchartable':
            return `
          &:hover {
            cursor: not-allowed;

            span {
              opacity: 1;
              transition-delay: 0.2s;
              left: -248px;
            }
          }
        `;
      }
   }}
`;

export const TableChartCellTooltip = styled.span`
   display: inline-block;
   height: 39px;
   left: -5000px;
   top: 5px;
   color: ${COLOR.WHITE};
   font-weight: ${FONT.WEIGHT.DEFAULT};
   white-space: nowrap;
   opacity: 0;
   position: absolute;
   z-index: 2;
   padding: 6px 0 0 8px;
   font-size: 12px;
   width: 240px;
   text-align: left;

   background-color: ${COLOR.BLACK};
   &:after {
      content: '';
      width: 0px;
      height: 0px;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid ${COLOR.BLACK};
      position: absolute;
      top: 12px;
      right: -9px;
   }
`;
